import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./Login";
import Home from "./User/Home";
import AdminPanel from "./Admin/AdminPanel";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom"; // Asegúrate de importar useNavigate

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  ); 
}

const AppContent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token")) {
      if (localStorage.getItem("rol") === "admin") {
        navigate("/admin");
      } else navigate("/home"); 
    } else {
      navigate("/login"); // Si no existe, redirige al login
    }
    //navigate("/login")
  }, [navigate]);

  return (
    <div>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </div>
  );
};

export default App;
